import { Dict, mergeWith } from '@chakra-ui/utils';
import { shadows } from '../foundations';
import { Button } from './button';

const baseStyle = (props: Dict): Dict => {
  const plainStyle = Button.variants.plain(props);

  return mergeWith({}, Button.baseStyle, {
    backgroundColor: 'slate.30',
    color: 'slate.900',
    boxShadow: 'button',
    _hover: {
      backgroundColor: 'slate.50',
    },
    _active: {
      backgroundColor: 'slate.50',
      boxShadow: 'none',
    },
    '&[data-focus-visible-within]': {
      boxShadow: `${shadows.focusVisible}, ${shadows.button}`,
    },
    '&[data-checked]': {
      ...plainStyle,
      boxShadow: 'none',
      '&[data-focus-visible-within]': {
        boxShadow: 'focusVisible',
      },
    },
    _disabled: {
      pointerEvents: 'none',
    },
  }) as Dict;
};

const sizes = Button.sizes;

const defaultProps = {
  size: 'md',
  colorScheme: 'light-blue',
};

export const ToggleButton = {
  baseStyle,
  sizes,
  defaultProps,
};
